import app from '../../app';
import payment_popup from '../../templates/paymentUpgrade';
import moment from '../../libs/moment';
import _ from '../../libs/lodash';
import plansModel from '../../models/plans';
import paymentInternal from '../payment/paymentInternal';
import helperPlan from '../../helpers/plans';
import helperFeedback from '../../helpers/feedback';
import icon_close from '../../svg/close.svg';
import videoLayout from '../videoLayout/main';
import studentPopup from '../studentPopup/main';
import calculateMainWindowSize from '../../helpers/calculateMainWindowSize';
import viewModes from '../../helpers/viewModes';
import planModel from '../../models/plans';
import globalStore from '$$store/main';
import constants from '../../helpers/constants';

const __ = window.__;

function ValidURL(str) {
  const pattern = new RegExp(/\(?(?:(http|https|ftp):\/\/)?(?:((?:[^\W\s]|\.|-|[:]{1})+)@{1})?((?:www.)?(?:[^\W\s]|\.|-)+[\.][^\W\s]{2,4}|localhost(?=\/)|\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})(?::(\d*))?([\/]?[^\s\?]*[\/]{1})*(?:\/?([^\s\n\?\[\]\{\}\#]*(?:(?=\.)){1}|[^\s\n\?\[\]\{\}\.\#]*)?([\.]{1}[^\s\?\#]*)?)?(?:\?{1}([^\s\n\#\[\]]*))?([\#][^\s\n]*)?\)?/gi);

  return pattern.test(str);
}

export default (() => {
  if (!app.config.mode.isBase) {
    return {};
  }

  let link = '';

  const innerSettings = {
    fullScreen: false,
    popupType: '',
    initState: false,
    openPlansDropdown: false,
  };

  var innerObject = {
    views: {
      main: {
        id: 'paymentPlanInfoPopup',
      },
      contactUsPopup: {
        id: 'contact-us-popup',
      },
      popupCancelSubscriptionToUpdate: {
        id: 'popupCancelSubscriptionToUpdate',
      },
      popupDismissToUpdate: {
        id: 'popupDismissToUpdate',
      },
      popupOrderInProgress: {
        id: 'popupOrderInProgress',
      },
    },
    init: {
      run(data) {
        let sizeType = 'general';
        const isTeam = data.team;

        if (user.affiliate && user.affiliate.percent && user.affiliate.coupon && user.affiliate.isStillValid) {
          data.type = 'affiliate';
          sizeType = data.type;
        }

        innerSettings.popupType = data.subjectView || data.type;
        innerSettings.initState = true;
        innerSettings.fullScreen = innerSettings.popupType.indexOf('history') !== -1;

        $$('paymentPlanInfoPopup').define('template', payment_popup.getMainPaymentTemplate(innerSettings.fullScreen, isTeam));
        $$('paymentPlanInfoPopup').resize();

        if ($$('paymentPlanInfoPopup').isVisible()) {
          $$('paymentPlanInfoScrollView').scrollTo(0, 0);
          $$('paymentPlanInfoPopup').hide();
          innerObject.handlers.showTheNewProjectPopup();

          return true;
        }
        $$('paymentPlanInfoPopup').show();

        $$('paymentPlanInfoPopup').resize();
        payment_popup.handle(data.type);
        innerObject.handlers.scrollToBottom();
      },
    },
    handlers: {
      scrollToBottom() {
        const realResources = globalStore.getters['resourcesModel/getAllRealResources'];

        if (realResources.length > 15) {
          $$('paymentPlanInfoScrollView').scrollTo(0, 700);
        } else {
          return false;
        }
      },
      refreshPlanInfo() {
        const viewTemplate = $$('paymentPlanInfoPopupBody');
        const viewTemplateHeader = $$('paymentPlanInfoHeader');

        viewTemplateHeader.define('template', payment_popup.getMainPaymentTemplateHeader);
        viewTemplateHeader.refresh();

        viewTemplate.define('template', payment_popup.getMainPaymentTemplate);
        viewTemplate.refresh();

        payment_popup.handle();
        $$('paymentPlanInfoScrollView').scrollTo(0, 0);
        innerObject.handlers.scrollToBottom();
      },
      setCurrentPlanToCard(newPlan, newPeriod, dataMore, discount) {
        const paymentCard = document.querySelector('.payment-body-container-block.ten-users');
        const pricingTooltip = document.querySelector('.payment-body-header-tooltip');
        const tooltipTitle = pricingTooltip.querySelector('h4');
        const currentValue = paymentCard.querySelector(`.block__price[data-period='${newPeriod}']`);
        const currentPriceTemplate = currentValue.querySelector('.block__price-value');
        const currentOldPriceTemplate = currentValue.querySelector('.block__price-old');
        const currentSelectPlanCaption = paymentCard.querySelector('.caption');
        const tillText = `<div class="js-discount-price">${__('coupon_till').toLowerCase()} ${payment_popup.momentFormat()}</div>`;
        const planAmount = newPlan.slice(4);

        let newPlanObj;
        let newPlanPriceTemplate;
        let newSelectPlanCaption;
        let newDiscountPrice;
        let newOldPriceTemplate;
        let newPlanTeamObj;
        let newTooltipTitle;

        newPlanObj = helperPlan.getDataPlanTeam(newPeriod, planAmount);
        newPlanTeamObj = helperPlan.getDataPlanTeam(null, planAmount);
        newSelectPlanCaption = `<span class="option_text"><strong>${planAmount}</strong> ${__('app_payment_switch')}</span>`;
        newDiscountPrice = Math.round((newPlanObj.price - newPlanObj.price / 100 * discount) * 100) / 100;

        if (dataMore) {
          newSelectPlanCaption = `${__('app_payment_switch_more_40')}`;
        }

        if (newPlanObj) {
          if (discount) {
            newPlanPriceTemplate = `${'<div class="value value_promotion">' + '<sup>$</sup>'}${payment_popup.beautifyPrice(newDiscountPrice.toFixed(2))}</div>${tillText}`;
          } else {
            newPlanPriceTemplate = `${'<div class="value">' + '<sup>$</sup>'}${newPlanObj.priceTemplate}</div>`;
          }
        }

        if (newPlanTeamObj) {
          const users = newPlanTeamObj.teamUsers;
          const monthPrice = (newPlanTeamObj.month.price * 12) * users;
          const yearPrice = (newPlanTeamObj.year.price * 12) * users;
          const save = Math.ceil(monthPrice - yearPrice);

          if (user.locale === 'kr') {
            newTooltipTitle = `$${save} ${__('pricing_tooltip_title')}`;
          } else {
            newTooltipTitle = `${__('pricing_tooltip_title')} ` + `$${save}`;
          }
        }

        if (currentOldPriceTemplate) {
          newOldPriceTemplate = `${'<div class="value">' + '<sup>$</sup>'}${payment_popup.beautifyPrice(newPlanObj.price.toFixed(2))}</div>`;
          currentOldPriceTemplate.innerHTML = newOldPriceTemplate;
        }

        currentSelectPlanCaption.innerHTML = newSelectPlanCaption;
        currentPriceTemplate.innerHTML = `${newPlanPriceTemplate}`;
        tooltipTitle.innerHTML = `${newTooltipTitle}`;
        pricingTooltip.classList.remove('dnone');
      },
      listenPaymentPlanSwitchButton(target, dataMore) {
        const selectPlan = document.querySelector('.select-plan');
        const selectPlanDropdown = selectPlan.querySelector('.dropdown');
        const selectPlanCaption = selectPlan.querySelector('.caption');
        let currentPlan;

        if (target && target.closest('.changePlanOption')) {
          selectPlan.querySelectorAll('.changePlanOption').forEach(item => item.classList.remove('selected'));
          target.closest('.changePlanOption').classList.add('selected');

          selectPlanCaption.innerHTML = target.innerHTML;

          if (!dataMore) {
            target.closest('.payment-body-container-block').classList.remove('boldCheck');
          } else {
            target.closest('.payment-body-container-block').classList.add('boldCheck');
          }

          currentPlan = target.closest('.payment-body-container-block').querySelector('.caption').getAttribute('data-plan');
          selectPlanCaption.setAttribute('data-plan', `${currentPlan}`);

          if (dataMore) {
            selectPlanCaption.setAttribute('data-more', dataMore);
          }

          selectPlanDropdown.classList.remove('open');
          innerSettings.openPlansDropdown = false;
        }
      },
      submitFormStudent() {
        const urlValidate = document.getElementById('js-form-validation').value;
        const urlStudentIdValidate = document.getElementById('js-student-id-form-validation').value;

        const validURL = ValidURL(urlValidate);
        const validStudentURL = ValidURL(urlStudentIdValidate);

        if (validURL && validStudentURL) {
          const message = `${urlValidate}\n${urlStudentIdValidate}`;

          innerObject.handlers.sendEmail(message);
          studentPopup.init();
          document.getElementById('js-form-validation').value = '';
          document.getElementById('js-student-id-form-validation').value = '';
        } else if (validURL && !validStudentURL) {
          document.querySelector('.form_error-student').classList.remove('isVisible');
          document.querySelector('.form_input-student').classList.add('form-error-border');

          return false;
        } else if (!validURL && validStudentURL) {
          document.querySelector('.form_error').classList.remove('isVisible');
          document.querySelector('.form_input').classList.add('form-error-border');

          return false;
        } else {
          document.querySelector('.form_error').classList.remove('isVisible');
          document.querySelector('.form_input').classList.add('form-error-border');
          document.querySelector('.form_error-student').classList.remove('isVisible');
          document.querySelector('.form_input-student').classList.add('form-error-border');

          return false;
        }
      },

      submitFormStudentYear() {
        const urlValidateYear = document.getElementById('js-form-validation-year').value;
        const urlReviewValidateYear = document.getElementById('js-form-validation-review-year').value;

        const validURL = ValidURL(urlValidateYear);
        const validReviewURL = ValidURL(urlReviewValidateYear);

        if (validURL && validReviewURL) {
          const message = `${urlValidateYear}\n${urlReviewValidateYear}`;

          innerObject.handlers.sendEmail(message);
          studentPopup.init();
          document.getElementById('js-form-validation-year').value = '';
          document.getElementById('js-form-validation-review-year').value = '';
        } else if (validURL && !validReviewURL) {
          document.querySelector('.form_error-year-review').classList.remove('isVisible');
          document.querySelector('.form_input-review-year').classList.add('form-error-border');

          return false;
        } else if (!validURL && validReviewURL) {
          document.querySelector('.form_error-year').classList.remove('isVisible');
          document.querySelector('.form_input-year').classList.add('form-error-border');
        } else {
          document.querySelector('.form_error-year').classList.remove('isVisible');
          document.querySelector('.form_input-year').classList.add('form-error-border');
          document.querySelector('.form_error-year-review').classList.remove('isVisible');
          document.querySelector('.form_input-review-year').classList.add('form-error-border');
        }
      },

      // email: user.email,
      // user_name: user.username,
      // last_name: user.firstName,
      // first_name: user.lastName,
      // companyName: user.settings.user_company,
      // lang: user.locale,
      // user_id: user.id,

      sendEmail(message) {
        helperFeedback.send({
          message,
          type: 'student-app-pricing-form',
          send_followup_email: true,
        });
      },

      hidePopup() {
        $$('paymentPlanInfoPopup').hide();
      },
      cancelSubscription() {
        plansModel.suspend(data => {
          if (data.isSuccess) {
            webix.message({ type: 'success', text: __('profile_successSuspend'), expire: 10000 });
            user.team.status_code = 8;
            user.subscription.status_code = 8;

            $$(innerObject.views.popupCancelSubscriptionToUpdate.id).hide();

            const win = window.open(link, '_blank');

            win.focus();
          } else {
            webix.message({ type: 'warning', text: __('profile_errorSuspend'), expire: 10000 });
            link = '';
          }
        });
      },
      showTheNewProjectPopup() {
        // var doesUserHaveProject = $$("teamProjectList").count() === 0;

        // doesUserHaveProject && app.trigger("templates:init");
      },
      resetFormStudentLayout: state => {
        if (state === 'left') {
          document.getElementById('js-form-validation-year').value = '';
          document.querySelector('.form_error-year').classList.add('isVisible');
          document.querySelector('.form_input-year').classList.remove('form-error-border');
        } else {
          document.getElementById('js-form-validation').value = '';
          document.querySelector('.form_error').classList.add('isVisible');
          document.querySelector('.form_input').classList.remove('form-error-border');
        }
      },
      setHeightTabSection: state => {
        const $$paymentPlanInfoPopupBody = $$('paymentPlanInfoPopupBody');
        const studentMainHead = document.querySelector('.student-main-head');
        let heightPageMain;

        if (state === 'left') {
          const leftSectionContent = document.querySelector('.student-main-layout-left');

          heightPageMain = studentMainHead.offsetHeight + leftSectionContent.offsetHeight;
        } else {
          const rightSectionContent = document.querySelector('.student-main-layout-right');

          heightPageMain = studentMainHead.offsetHeight + rightSectionContent.offsetHeight;
        }

        $$paymentPlanInfoPopupBody.getNode().querySelector('.payment-body-student-page-main').style.height = `${heightPageMain}px`;
        $$paymentPlanInfoPopupBody.resize();
      },
      toggleTabStudentLayout: state => {
        innerObject.handlers.resetFormStudentLayout(state);
        state === 'left' ? payment_popup.tabsStudentLeft() : payment_popup.tabsStudentRight();
        innerObject.handlers.setHeightTabSection(state);
      },
    },
    helpers: {
      openChat() {
        const chat = document.getElementById('chat-widget-container');

        if (chat) {
          chat.style.display = '';
        } else {
          user.settings.jivo_chat = 1;
          app.trigger('init:supportChat');
        }

        setTimeout(() => {
          LC_API && LC_API.open_chat_window();
          $$('need-more-projects-popup').hide();
        }, 1000);
      },
    },
  };

  const outputObject = {
    handlers: {
      hidePopup() {
        $$('paymentPlanInfoPopup').hide();
        webix.callEvent('onResize', []);
      },
    },
  };

  webix.ui({
    view: 'window',
    id: 'paymentPlanInfoPopup',
    css: 'paymentPlanInfoPopup',
    borderless: true,
    position(state) {
      if (viewModes.overTrialOrSubscription()) {
        const leftSideBarWidth = globalStore.getters.leftSidebarWidth;

        state.height = document.body.clientHeight;
        state.width = document.body.clientWidth - leftSideBarWidth;

        this.config.height = state.height;

        state.left = leftSideBarWidth + 1;
        state.top = 0;
      } else {
        calculateMainWindowSize.apply(this, [state, true]);
      }
    },
    head: {
      id: 'paymentPlanInfoHeader',
      css: 'payment_plan_info_header topHeaderShadow',
      height: 60,
      minWidth: 972,
      paddingY: 0,
      paddingX: 0,
      borderless: true,
      template: app.config.mode.isBase ? payment_popup.getMainPaymentTemplateHeader(innerSettings.fullScreen, true) : '',
      onClick: {
        'tooltip-closer': function (e) {
          const tooltip = e.target.closest('.payment-body-header-tooltip');

          tooltip.classList.add('dnone');
        },
        'payment-body-header-button': function () {
          $$('paymentPlanInfoScrollView').scrollTo(0, 0);
          innerObject.handlers.hidePopup();
        },
        back_btn() {
          innerObject.handlers.refreshPlanInfo();
        },

        onBeforeShow() {
          app.trigger('popup:show');
        },
        onAfterScroll() {
          document.querySelector('.payment-body-header-tooltip').style.display = '';
        },
        onHide() {
          app.trigger('popup:hide');
          webix.callEvent('onResize', []);
        },
        onShow() {
          webix.callEvent('onResize', []);
          webix.ajax().post('/api/pipedrive', { pricing_open_times: '+1' });
        },
      },
    },
    body: {
      view: 'scrollview',
      id: 'paymentPlanInfoScrollView',
      minWidth: 972,
      // minHeight: 100,
      scroll: !innerSettings.openPlansDropdown ? 'y' : false, //
      borderless: true,
      body: {
        borderless: true,
        view: 'template',
        id: 'paymentPlanInfoPopupBody',
        autoheight: true,
        minHeight: 660,
        css: 'payment-body',
        template: payment_popup.getMainPaymentTemplate(innerSettings.fullScreen, true),
        onClick: {
          'select-plan': function () {
            document.addEventListener('click', e => {
              if (e.target && !e.target.closest('.select-plan')) {
                if (document.querySelector('.select-plan .container .dropdown')) {
                  document.querySelector('.select-plan .container .dropdown').classList.remove('open');
                  innerSettings.openPlansDropdown = false;
                }
              }
            });
          },
          changePlanOption(e) {
            const dataPlan = e.target.closest('.changePlanOption').getAttribute('data-plan');
            const selectPlanCaption = document.querySelector('.select-plan .caption');
            const dataPeriod = selectPlanCaption.getAttribute('data-period');
            let dataMore;

            if (e.target.closest('.option__info-icon')) return;

            selectPlanCaption.setAttribute('data-plan', dataPlan);

            if (e.target.closest('.changePlanOption').getAttribute('data-more')) {
              dataMore = e.target.closest('.changePlanOption').getAttribute('data-more');
            }
            /// ///
            app.trigger('changePayment', dataPlan, dataPeriod, e.target, dataMore, true);
          },
          caption() {
            document.querySelector('.dropdown').classList.toggle('open');

            const list = document.querySelector('.list');
            const listHeight = list.offsetHeight;
            const selectItem = document.querySelector('.list .selected');
            const selectItemTopPos = selectItem.offsetTop;

            list.scrollTo(0, (selectItemTopPos - listHeight / 2));

            innerSettings.openPlansDropdown = document.querySelector('.dropdown').classList.contains('open');
          },
          'form-btn-link': function () {
            innerObject.handlers.submitFormStudent();
          },
          'form-btn-link-year': function () {
            innerObject.handlers.submitFormStudentYear();
          },

          'js-tabs-left': function () {
            innerObject.handlers.toggleTabStudentLayout('left');

            webix.delay(() => {
              webix.callEvent('onClick', []);
            }, null, [], 500);
          },

          'js-tabs-right': function () {
            innerObject.handlers.toggleTabStudentLayout('right');

            webix.delay(() => {
              webix.callEvent('onClick', []);
            }, null, [], 500);
          },

          'js-show-global-video-fullscreen': function (e) {
            videoLayout.init(e);
          },
          'payment-body-header-button': function () {
            $$('paymentPlanInfoScrollView').scrollTo(0, 0);
            innerObject.handlers.hidePopup();
          },
          'payment-body-footer-jivo': function () {
            LC_API.open_chat_window(); // open Jivo chat

            return false;
          },
          'footer-btn': function () {
            //

            const viewTemplate = $$('paymentPlanInfoPopupBody');
            const viewTemplateHeader = $$('paymentPlanInfoHeader');

            viewTemplateHeader.define('template', payment_popup.getMainPaymentTemplateStudentHeader());
            viewTemplateHeader.refresh();
            viewTemplateHeader.resize();

            viewTemplate.define('template', payment_popup.getMainPaymentTemplateStudent());
            viewTemplate.refresh();

            innerObject.handlers.toggleTabStudentLayout('left');

            $$('paymentPlanInfoScrollView').scrollTo(0, 0);

            webix.delay(() => {
              webix.callEvent('onClick', []);
            }, null, [], 500);
          },
          'payment-body-container-block-button': function (e) {
            const targetElement = e.target.closest('.payment-body-container-block-button');
            const selectPlanCaption = document.querySelector('.select-plan .caption');
            const dataPeriod = selectPlanCaption.getAttribute('data-period');

            if (targetElement && targetElement.classList.contains('contact-us')) {
              e.preventDefault();

              return;
            }
            if (targetElement && targetElement.classList.contains('disabled-plan-button')) {
              e.preventDefault();

              return;
            }

            if (targetElement.closest('.best-plan') && _.isUndefined(targetElement.closest('.best-plan').querySelector('.caption').dataset.plan)) {
              e.preventDefault();

              return;
            }

            if (user.team && user.team.activites === 0 && _.isNumber(user.team.role_id) && user.team.role_id !== 1) {
              e.preventDefault();
              $$(innerObject.views.popupDismissToUpdate.id).show();

              return;
            }

            if (user.subscription.status_code === 110) {
              e.preventDefault();
              $$(innerObject.views.popupOrderInProgress.id).show();

              return;
            }

            let captionBtn;

            if (targetElement.closest('.block-individual')) {
              captionBtn = targetElement;
            } else {
              captionBtn = targetElement.parentElement.querySelector('.caption');
            }
            const newPeriod = captionBtn.dataset.period;

            if (plansModel.isTrial()) {
              let newPlan;

              if (captionBtn.dataset.plan === 'pro') {
                newPlan = helperPlan.getDataPlanPro().year;
                newPlan.userCount = 1;
                newPlan.planId = 14;
              } else {
                const planAmount = captionBtn.dataset.plan.slice(4);

                newPlan = helperPlan.getDataPlanTeam(newPeriod, planAmount);
                newPlan.planId = 14;
                newPlan.userCount = 5;
              }

              paymentInternal.handlers.showPopup(targetElement, {
                newPlan,
                newPeriod,
                subjectView: innerSettings.popupType,
              });

              return;
            }

            switch (user.subscription.status_code) {
            case 1:
            case 5:
            case 6:
            case 7:
            case 9:
            case 12:
              e.preventDefault();
              $$(innerObject.views.popupCancelSubscriptionToUpdate.id).show();
              break;
            default:
              let newPlan;

              if (captionBtn.dataset.plan === 'pro') {
                newPlan = helperPlan.getDataPlanPro().year;
              } else {
                const planAmount = captionBtn.dataset.plan.slice(4);

                newPlan = helperPlan.getDataPlanTeam(newPeriod, planAmount);
              }

              paymentInternal.handlers.showPopup(targetElement, {
                newPlan,
                newPeriod,
                subjectView: innerSettings.popupType,
              });
              break;
            }
          },
          'contact-us': function () {
            app.trigger('messageUsForm:show', 'price-app-contact-us-form');
          },
          'contact-us-button': function () {
            app.trigger('messageUsForm:show', 'price-app-contact-us-form');
          },
        },
        on: {
          onKeyPress(code, e) {
            if (code === 13 && e.target.classList.contains('form_input')) {
              e.preventDefault();
              innerObject.handlers.submitFormStudent();
            } else if (code === 13 && e.target.classList.contains('form_input-year')) {
              e.preventDefault();
              innerObject.handlers.submitFormStudentYear();
            }
          },
        },
      },
      on: {
        onAfterScroll() {
        },
        onAfterShow() {
        },
      },
    },
    on: {
      onBeforeShow() {
        app.trigger('popup:show');
      },
      onAfterScroll() {
        document.querySelector('.payment-body-header-tooltip').style.display = '';
      },
      onHide() {
        app.trigger('popup:hide');
        webix.callEvent('onResize', []);
      },
      onShow() {
        webix.callEvent('onResize', []);
        if (globalStore.getters['user/getActivityStatus'](constants.USER_ACTIVITIES.PAYMENT) === 0) {
          globalStore.dispatch('user/updateActivityStatus', {
            activityName: constants.USER_ACTIVITIES.PAYMENT,
            status: 1,
          });
        }

        const bestPlan = $$('paymentPlanInfoPopupBody').getNode().querySelector('.payment-body-container-block.best-plan');
        const boldCheck = globalStore.getters['resourcesModel/getAllRealResources'].length > 40 ? 'boldCheck' : '';

        if (bestPlan && boldCheck) {
          bestPlan.classList.add(boldCheck);
        }

        webix.ajax().post('/api/pipedrive', { pricing_open_times: '+1' });
      },
    },
  }).hide();

  //

  webix.ui({
    view: 'popupWithoutPadding',
    id: 'need-more-projects-popup',
    css: 'need-more-projects-popup',
    width: 615,
    height: 587,
    hidden: true,
    body: {
      paddingX: 0,
      paddingY: 0,
      borderless: true,
      rows: [
        {
          view: 'template',
          borderless: true,
          template() {
            return `${"<div class='need-more-projects-popup-container'>"
              + '<div>'
              + "<h1 class='need-more-projects-popup-header'>"}${__('need_more_projects_header')}</h1>`
              + `<p class='need-more-projects-popup-text'>${__('need_more_projects_text')}</p>`
              + '</div>'
              + '<div class=\'need-more-projects-popup-image\'>'
              + '</div>'
              + '<div class=\'need-more-projects-popup-footer\'>'
              + `<div class='need-more-projects-popup-button'>${__('contact_us')}</div>`
              + '</div>'
              + '</div>';
          },
          onClick: {
            'need-more-projects-popup-button': function () {
              innerObject.helpers.openChat();
            },
          },
        },
      ],
    },
  });

  app.on('popup:show', () => {
    if (app.config.mode.isBase) {
      innerObject.handlers.refreshPlanInfo();
    }

    $$('paymentPlanInfoPopup').hide();
  });

  app.on('popup:closeOther', id => {
    if (id !== $$('paymentPlanInfoPopup')) {
      $$('paymentPlanInfoPopup').hide();
    }
  });

  app.on('gantt:area:click', () => {
    $$('paymentPlanInfoPopup').hide();
  });

  app.on('paymentPlanInfo:show', data => {
    app.trigger('popup:closeOther', 'paymentPlanInfoPopup');
    // routerHelper.changeRoute('/');
    innerObject.init.run(data);
  });

  app.on('paymentPlanInfo:show:popup', data => {
    $$('need-more-projects-popup').show(data.element.getNode(), {
      pos: 'right',
      x: 10,
    });
  });

  app.on('body:resize', data => {
    $$('paymentPlanInfoPopup').resize();
  });

  app.on('paymentPlanInfo:hide', () => {
    $$('paymentPlanInfoPopup').hide();
  });

  app.on('leftSideBar:changedMode', data => {
    $$('paymentPlanInfoPopup').resize();
  });

  app.on('tab:projectClick', data => {
    $$('paymentPlanInfoPopup').hide();
  });

  app.on('changePayment', (dataPlan, dataPeriod, target, dataMore) => {
    if (!$$('paymentPlanInfoPopup')) return false;

    const discount = planModel.getAffiliate();
    // document.body.classList.contains('isDiscount');

    if (target) {
      innerObject.handlers.listenPaymentPlanSwitchButton(target, dataMore);
    }

    innerObject.handlers.setCurrentPlanToCard(dataPlan, dataPeriod, dataMore, discount);
  });

  webix.ui({
    view: 'ganttproWindowPopup',
    id: innerObject.views.popupCancelSubscriptionToUpdate.id,
    width: 600,
    position: 'center',
    css: 'clear-window-popup popupCancelSubscriptionToUpdate',
    autoheight: true,
    // modal: true,
    borderless: true,
    head: {
      paddingY: 18,
      height: 60, // 48
      cols: [
        {
          view: 'label',
          align: 'center',
          label: __('upgrade_cancelSubscription_title'),
        },
      ],
    },
    body: {
      paddingX: 36,
      paddingY: 30,
      type: 'space',
      rows: [
        {
          view: 'template',
          borderless: true,
          autoheight: true,
          template: __('upgrade_cancelSubscription_content', {
            plan: user.subscription.name,
            date: moment(user.subscription.date_to).format('YYYY-MM-DD HH:mm'),
          }),
        },
        {},
        {
          cols: [
            {
              view: 'button',
              align: 'right',
              width: 200,
              value: __('common_suspend'),
              css: 'webix_button_default button_raised',
              on: {
                onItemClick() {
                  innerObject.handlers.cancelSubscription();
                },
              },
            },
            {},
            {
              view: 'button',
              value: __('upgrade_cancelSubscription_button_close'),
              css: 'button_default',
              on: {
                onItemClick() {
                  $$(innerObject.views.popupCancelSubscriptionToUpdate.id).hide();
                },
              },
            },
          ],
        },
      ],
    },
    onBeforeShow() {
      app.trigger('popup:show');
    },
    onHide() {
      app.trigger('popup:hide');
    },
  }).hide();

  webix.ui({
    view: 'ganttproWindowPopup',
    id: innerObject.views.popupDismissToUpdate.id,
    width: 600,
    position: 'center',
    css: 'clear-window-popup',
    autoheight: true,
    // modal: true,
    borderless: true,
    hidden: true,
    head: {
      height: 48,
      cols: [
        { width: 50 },
        {
          view: 'label',
          align: 'center',
          label: __('upgrade_dismissToUpdate_title'),
        },
        {
          view: 'icon',
          width: 50,
          template: `<div class='window_header_icon'>${icon_close}</div>`,
          on: {
            onItemClick() {
              $$(innerObject.views.popupDismissToUpdate.id).hide();
            },
          },
        },
      ],
    },
    body: {
      paddingX: 36,
      paddingY: 30,
      type: 'space',
      rows: [
        {
          view: 'template',
          borderless: true,
          autoheight: true,
          template: __('upgrade_dismissToUpdate_content'),
        },
      ],

    },
  }).hide();

  webix.ui({
    view: 'ganttproWindowPopup',
    id: innerObject.views.popupOrderInProgress.id,
    width: 600,
    position: 'center',
    css: 'clear-window-popup',
    autoheight: true,
    // modal: true,
    borderless: true,
    hidden: true,
    head: {
      height: 48,
      cols: [
        { width: 50 },
        {
          view: 'label',
          align: 'center',
          label: __('upgrade_popupOrderInProgress_title'),
        },
        {
          view: 'icon',
          width: 50,
          template: `<div class='window_header_icon'>${icon_close}</div>`,
          on: {
            onItemClick() {
              $$(innerObject.views.popupOrderInProgress.id).hide();
            },
          },
        },
      ],
    },
    body: {
      paddingX: 36,
      paddingY: 30,
      type: 'space',
      rows: [
        {
          view: 'template',
          borderless: true,
          autoheight: true,
          template: __('upgrade_popupOrderInProgress_content'),
        },
      ],

    },
  }).hide();

  return outputObject;
})();
